/* eslint-disable import/prefer-default-export */
export const isSuperAdmin = (user) => user?.attributes.superAdmin;
